<div class="tools-item" *lmsProfileGuard="action">
  <lms-button-select
    *ngIf="canDecrease"
    [id]="manageButtonLabel"
    [title]="manageButtonLabel"
    [text]="manageButtonLabel"
  >
    <li>
      <a [id]="action" (click)="openPurchaseModal()">{{ action | translate }}</a>
    </li>
    <li>
      <a [id]="decreaseAction" (click)="openDecreaseModal()">{{ decreaseAction | translate }}</a>
    </li>
  </lms-button-select>
  <gl-button
    *ngIf="!canDecrease"
    color-primary
    [id]="action"
    [text]="action | translate"
    title="{{ action | translate }}"
    (onClick)="openPurchaseModal()"
  ></gl-button>
</div>

<lms-modal #modalCreditsDealer size="small" [ngClass]="transactionType">
  <div class="gl-popup__close" (click)="popupClose()">
    <span class="glicon-close"></span>
  </div>
  <div class="gl-popup__title">
    {{ (isDecrease ? decreaseAction : action) | translate }}
  </div>
  <div class="gl-popup__heading--data">
    {{ (distributor.subscriptions.credits ? 'distributors.creditsBalance' : 'distributors.balanceSeats') | translate }}:
    <b>{{ distributor.brokerBalance.amount }}</b>
  </div>
  <div class="gl-popup__scroll--iframe noWidthOverflow">
    <lms-dynamic-form
      [action]="action"
      [options]="{ disableCard: true }"
      [questions]="questions"
      (submit)="createTransaction($event)"
    >
      <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="popupClose()" form-actions-before>
      </gl-button>
    </lms-dynamic-form>
  </div>
</lms-modal>
